import type { StaffMe } from "../../api/types";
import type { AppSession } from "../lib/storage";

export type StaffIdentity = NonNullable<AppSession["staff"]>;

export const toStaffIdentity = (staff: StaffMe): StaffIdentity => ({
  userId: staff.id,
  fullName: [staff.first_name, staff.last_name].filter(Boolean).join(" "),
});
